import { prisma } from '../../shared/prisma';
import { AppError } from '../../shared/errors/AppError';

export async function createCompany(data: { name: string; description?: string }) {
  if (!data.name?.trim()) {
    throw new AppError(400, 'Company name is required');
  }
  
  const existing = await prisma.company.findFirst({
    where: { name: { equals: data.name, mode: 'insensitive' } }
  });
  if (existing) {
    throw new AppError(400, `Company "${data.name}" already exists`);
  }

  return prisma.company.create({
    data: {
      name: data.name,
      description: data.description
    }
  });
}

export async function listCompanies() {
  return prisma.company.findMany({
    include: { departments: true },
    orderBy: { name: 'asc' }
  });
}

export async function deleteCompany(id: string) {
  return prisma.company.delete({
    where: { id }
  });
}

export async function createDepartment(data: { companyId: string; name: string; description?: string }) {
  if (!data.companyId) {
    throw new AppError(400, 'Company ID is required');
  }
  if (!data.name?.trim()) {
    throw new AppError(400, 'Department name is required');
  }

  const company = await prisma.company.findUnique({
    where: { id: data.companyId }
  });
  if (!company) {
    throw new AppError(404, 'Company not found');
  }

  const existing = await prisma.department.findFirst({
    where: {
      companyId: data.companyId,
      name: { equals: data.name, mode: 'insensitive' }
    }
  });
  if (existing) {
    throw new AppError(400, `Department "${data.name}" already exists in this company`);
  }

  return prisma.department.create({
    data: {
      companyId: data.companyId,
      name: data.name,
      description: data.description
    },
    include: { company: true }
  });
}

export async function listDepartments(companyId?: string) {
  const where = companyId ? { companyId } : {};
  return prisma.department.findMany({
    where,
    include: { company: true },
    orderBy: { name: 'asc' }
  });
}

export async function deleteDepartment(id: string) {
  return prisma.department.delete({
    where: { id }
  });
}
